var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaperSearch = function SvgPaperSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 63,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.495.613V15.68a2.09 2.09 0 0 0 2.09 2.09h15.068L34.495.613Z",
    fill: "#19336E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.984 57.512a13.578 13.578 0 0 1-17.715-7.337H12.544a1.046 1.046 0 0 1 0-2.09h16.059a13.4 13.4 0 0 1 .666-8.363H12.544a1.045 1.045 0 0 1 0-2.09H30.38a13.56 13.56 0 0 1 21.885-1.355V19.861H35.541a3.136 3.136 0 0 1-3.136-3.136V0H2.09A2.09 2.09 0 0 0 0 2.09v58.538a2.09 2.09 0 0 0 2.09 2.09h48.085c.535 0 1.05-.21 1.433-.584l-4.623-4.622Zm-34.44-40.787h9.407a1.045 1.045 0 1 1 0 2.09h-9.407a1.046 1.046 0 0 1 0-2.09Zm0 10.453h27.178a1.045 1.045 0 1 1 0 2.09H12.544a1.045 1.045 0 0 1 0-2.09Z",
    fill: "#19336E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M41.812 34.495a10.454 10.454 0 1 0 5.759 19.168l6.659 6.659a1.045 1.045 0 0 0 1.478 0l1.478-1.479a1.045 1.045 0 0 0 0-1.478l-6.659-6.658a10.442 10.442 0 0 0-8.715-16.212Zm0 18.816a8.362 8.362 0 1 1 8.363-8.363 8.372 8.372 0 0 1-8.363 8.363Z",
    fill: "#19336E"
  })));
};
export default SvgPaperSearch;